/*
===============================================================================================================
                                 Copyright 2024-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React from 'react';
import PropTypes from 'prop-types';
import TextDiv from '@/components/text-div';

function ToggleList({
  inputSelectorId, subControls, generateControl, label,
}) {
  return (
    <div id={inputSelectorId} className="wrapper">
      <div className="label-wrapper">
        {label && (
        <div className="label"><TextDiv>{label}</TextDiv></div>
        )}
      </div>
      <div className="subcontrols">
        {subControls.map((control) => (
          <div id="sub-control" key={control.id}>
            {generateControl(control, generateControl)}
          </div>
        ))}
      </div>
      <style jsx>
        {`
          .wrapper {
            display: flex;
            flex-direction: column;
            width: 100%;
          }

          .label-wrapper {
            display: flex;
            flex-direction: row;
            width: 100%;
            margin-bottom: ${subControls?.length ? 12 : 0}px;
          }

          .label {
            display: flex;
            align-items: center;
            font-size: var(--font-size-tooltip);
            font-weight: var(--font-weight-H1);
            flex: 1;
          }

          .subcontrols {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 8px;
          }
        `}
      </style>
    </div>
  );
}

ToggleList.defaultProps = {
  inputSelectorId: null,
  label: null,
  subControls: [],
  generateControl: null,
};

ToggleList.propTypes = {
  inputSelectorId: PropTypes.string,
  label: PropTypes.string,
  subControls: PropTypes.arrayOf(PropTypes.shape()),
  generateControl: PropTypes.func,
};

export default ToggleList;
